import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

export const useGoogleAnalytics = (environment: string, gaKey: string) => {
	const location = useLocation();

	const [initialPageLoad, setInitialPageLoad] = useState(false);
	const [isGAInitialized, setIsGAInitialized] = useState(false);

	const isLocal = ["localhost", "localmac", "192.", "127.0.0.1"].includes(window.location.hostname) || environment === "local";

	useEffect(() => {
		let startTracking = true;
		if (isLocal) {
			startTracking = false;
		}
		if (typeof window !== "undefined" && !isGAInitialized && startTracking) {
			//GA Analytics initialization
			ReactGA.initialize(gaKey);
			setIsGAInitialized(true);
		}

		if (!initialPageLoad && startTracking) {
			ReactGA.send({ hitType: "pageview", page: location.pathname });
			setInitialPageLoad(true);
		}
	}, [isGAInitialized]);

	useEffect(() => {
		let startTracking = true;
		if (isLocal) {
			startTracking = false;
		}

		if (startTracking && isGAInitialized) {
			ReactGA.send({ hitType: "pageview", page: location.pathname });
		}
	}, [isGAInitialized, location]);
};